import { FE_SIMPLIFIED_SEM_DISCOVER_V2_250303 } from "@faire/retailer-settings/FE_SIMPLIFIED_SEM_DISCOVER_V2_250303";
import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";

export const getSettingSimplifiedSemDiscoverV2 = (): boolean =>
  getSettingValueWithoutAssignment(FE_SIMPLIFIED_SEM_DISCOVER_V2_250303, false);
